module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/OperationTypeIcon.d9729fb1.svg";